import React from 'react';
import { FiX } from 'react-icons/fi';

const Modal = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  footer,
  maxWidth = 'max-w-6xl',
  headerColor = 'bg-primary-600'
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 dark:bg-opacity-50 z-50 overflow-y-auto py-4">
      <div className={`bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full ${maxWidth} my-auto`}>
        {/* Header avec couleur */}
        <div className={`${headerColor} text-white px-6 py-3 rounded-t-lg flex items-center justify-between`}>
          <h2 className="text-lg font-semibold">{title}</h2>
          <button
            onClick={onClose}
            className="text-white hover:text-gray-200 transition-colors p-1 rounded hover:bg-white hover:bg-opacity-20"
            aria-label="Fermer"
          >
            <FiX className="h-5 w-5" />
          </button>
        </div>
        
        {/* Contenu */}
        <div className="p-6">
          <div className="max-h-[75vh] overflow-y-auto pr-2">
            {children}
          </div>
          
          {/* Footer */}
          {footer && (
            <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
              {footer}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;

